import { render, staticRenderFns } from "./Vendite.vue?vue&type=template&id=e8b996fe&"
import script from "./Vendite.vue?vue&type=script&lang=js&"
export * from "./Vendite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports